import request from '@/utils/request'

export function selectUseridCallingCard(data) {
  return request({
    url: 'api/selectUseridCallingCard',
    method: 'post',
    params: data
  })
}

export function editCallingCard(data) {
  return request({
    url: 'api/editCallingCard',
    method: 'post',
    params: data
  })
}
export function editBrandInfo(data) {
  return request({
    url: 'api/editBrandInfo',
    method: 'post',
    params: data
  })
}

export function selectBrandInfoXCX() {
  return request({
    url: 'api/selectBrandInfoXCX',
    method: 'post'
  })
}
export function selectShowHallDataXCX(data) {
  return request({
    url: 'api/selectShowHallDataXCX',
    method: 'post',
    params: data
  })
}
export function editShowHall(data) {
  return request({
    url: 'api/editShowHall',
    method: 'post',
    params: data
  })
}
export function deleteShowHall(data) {
  return request({
    url: 'api/deleteShowHall',
    method: 'post',
    params: data
  })
}
export function getSmallProgramCode(data) {
  return request({
    url: 'api/getSmallProgramCode',
    method: 'post',
    params: data
  })
}
export function selectCardViewList(data) {
  return request({
    url: 'api/selectCardViewList',
    method: 'post',
    params: data
  })
}
export function selectLeaveWordList(data) {
  return request({
    url: 'api/selectLeaveWordList',
    method: 'post',
    params: data
  })
}

export function operLeaveWord(data) {
  return request({
    url: 'api/operLeaveWord',
    method: 'post',
    params: data
  })
}

export function createTheMaterial(data) {
  return request({
    url: 'api/createTheMaterial',
    method: 'post',
    params: data
  })
}

